import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DownloadService {
    download(file: File) {
        const link = document.createElement('a');
        const url = URL.createObjectURL(file);
        link.href = url;
        link.target = '_blank';
        link.download = file.name;
        link.click();

        setTimeout(() => {
            URL.revokeObjectURL(url);
        }, 60 * 1000);
    }
}
